// store/modules/ErreurTransCAM.js
//import { v4 as uuidv4 } from 'uuid';

export default {
    namespaced: true,

    state: () => ({
        erreurs: []
    }),

    getters: {
        getErreurs: (state) => state.erreurs,
        getErreursNonVues: (state) => state.erreurs.filter(e => !e.hasBeenSeen),
        getNbErreursNonVues: (state, getters) => getters.getErreursNonVues.length
    },

    mutations: {
        //ajouterErreur(state, erreur) {
        //    state.erreurs.push({
        //        ...erreur,
        //        hasBeenSeen: false,
        //        idErreur: uuidv4(),
        //        typeName: erreurTypeToName(erreur.type)
        //    });
        //},
        
        setErreur(state, erreurs) {
            state.erreurs=erreurs;
        },
        marquerCommeVue(state, idErreur) {
            const erreur = state.erreurs.find(e => e.idErreur === idErreur);
            if (erreur) {
                erreur.hasBeenSeen = true;
            }
        },

        resetErreurs(state) {
            state.erreurs = [];
        }
    },

    actions: {
        ajouterErreur({ commit }, erreur) {
            commit('ajouterErreur', erreur);
        },

        consulterErreur({ commit }, idErreur) {
            commit('marquerCommeVue', idErreur);
        },

        clearErreurs({ commit }) {
            commit('resetErreurs');
        }
    }
};

// Fonction utilitaire
function erreurTypeToName(type) {
    switch (type) {
        case 1: return "Info";
        case 2: return "Avertissement";
        case 3: return "Erreur";
        case 4: return "ErreurCritique";
        default: return "Inconnu";
    }
}
